import { onlinePayment } from './onlinePayment';

const createSupplierOrderOnlinePayment = {
  ...onlinePayment
};

export { createSupplierOrderOnlinePayment };